export default "__VITE_ASSET__BvvHpyN0__"